//TODO : Refactor after ai
/**
 * Rahmen der App v2: Modulnavigation links (mobil unten), Kopfzeile mit „Ansicht als“,
 * Zurücksetzen und Meldungen. Module nach KONZEPT.md.
 */
import { useEffect, type ReactNode } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Boxes,
  CalendarDays,
  ClipboardCheck,
  Database,
  Gauge,
  HardHat,
  Route,
  Users,
} from "lucide-react";
import { useDatenStore } from "@app/store";
import { alleRollen } from "@shared/demo-data/viacid";
import "./theme.css";

// Welche Rolle welches Modul sieht – nach den Actions in Notion (Durchgang 15.10.2026)
const ALLE = ["VB", "LV", "ID", "DI", "GF", "SU", "PM", "KO", "HA", "TD"];
const MODULE = [
  { zu: "/app", label: "Cockpit", icon: Gauge, ende: true, rollen: ALLE },
  {
    zu: "/app/kunden",
    label: "Kunden",
    icon: Users,
    rollen: ["VB", "LV", "ID", "DI"],
  },
  {
    zu: "/app/chancen",
    label: "Chancen & Angebote",
    icon: Route,
    rollen: ["VB", "LV", "ID", "KO", "HA"],
  },
  {
    zu: "/app/aufnahme",
    label: "Aufnahme",
    icon: ClipboardCheck,
    rollen: ["VB", "DI", "LV"],
  },
  {
    zu: "/app/planung",
    label: "Disposition",
    icon: CalendarDays,
    rollen: ["DI", "GF", "LV"],
  },
  {
    zu: "/app/baustelle",
    label: "Baustelle",
    icon: HardHat,
    rollen: ["GF", "SU", "PM", "DI"],
  },
  {
    zu: "/app/auftraege",
    label: "Aufträge",
    icon: Boxes,
    rollen: ["ID", "LV", "PM", "GF", "KO", "HA", "TD"],
  },
  {
    zu: "/app/daten",
    label: "Daten",
    icon: Database,
    rollen: ["VB", "LV", "ID", "DI", "GF", "SU", "PM"],
  },
];

export function AppShell({ children }: { children: ReactNode }) {
  const rolle = useDatenStore((s) => s.rolle);
  const setRolle = useDatenStore((s) => s.setRolle);
  const meldung = useDatenStore((s) => s.meldung);
  const schliessen = useDatenStore((s) => s.meldungSchliessen);
  const zuruecksetzen = useDatenStore((s) => s.zuruecksetzen);
  const nav = useNavigate();

  useEffect(() => {
    if (!meldung) return;
    const t = setTimeout(schliessen, 4500);
    return () => clearTimeout(t);
  }, [meldung, schliessen]);

  return (
    <div className="vc vc-shell">
      <nav className="vc-nav">
        <div className="logo">
          <img src="/viacid/logo.svg" alt="VIACID" />
        </div>
        {MODULE.filter((m) => m.rollen.includes(rolle)).map((m) => (
          <NavLink key={m.zu} to={m.zu} end={m.ende}>
            <m.icon />
            <span>{m.label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="vc-main">
        <header className="vc-top">
          <strong style={{ fontSize: "0.9rem" }}>Viacid App</strong>
          <span className="vc-pill">Prototyp · Beispieldaten</span>
          <div className="spacer" />
          <label style={{ fontSize: "0.78rem", color: "var(--vc-muted)" }}>
            Ansicht als
          </label>
          <select value={rolle} onChange={(e) => setRolle(e.target.value)}>
            {alleRollen().map((r) => (
              <option key={r.kuerzel} value={r.kuerzel}>
                {r.name}
                {r.intern ? "" : " (extern)"}
              </option>
            ))}
          </select>
          <button
            className="vc-btn ghost"
            onClick={() => {
              zuruecksetzen();
              nav("/app");
            }}
          >
            Zurücksetzen
          </button>
        </header>
        <main className="vc-content">{children}</main>
      </div>
      {meldung && (
        <div
          className={`vc-toast ${meldung.fehler ? "fehler" : ""}`}
          onClick={schliessen}
        >
          {meldung.text}
        </div>
      )}
    </div>
  );
}
